import { formatDate } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EmailService } from 'src/app/services/email.service';
import { TestService } from 'src/app/services/test.service';
import { UserService } from 'src/app/services/user.service';
import { Editor, toDoc, toHTML } from 'ngx-editor';

import Swal from 'sweetalert2';
import { DomainService } from 'src/app/services/domain.service';
import { CustomTestService } from 'src/app/services/custom-test.service';
import { CustomTest, TestGroup } from 'src/app/models/custom_test_model';
import { TestInfoModel } from 'src/app/models/test_info_model';
declare var $: any;
@Component({
  selector: 'app-create-evaluated',
  templateUrl: './create-evaluated.component.html',
  styleUrls: ['styles.css']
})
export class CreateEvaluatedComponent implements OnInit {

  @ViewChild('text1') text1: ElementRef;

  public editor:Editor;
  public html;
  public useCleaverHF = false;

  public newDate;
  public defaultEmail = true;
  public searching = false;
  public exists = false;
  public pswEdit = false;
  public subject = "Notificaciones";
  public mmpi2Extra = false;
  public mmpiaExtra = false;
  public baremo = "Argentina";
  public formModel = [];
  public radioField = [];
  public multipleField = [];
  public creatingFieldType = 'text';
  public title = '';
  public option = {
    text: '',
    value: null
  }
  public successMessage = '';
  public failMessage = '';
  public value = null;
  public correctValue = null;
  public forms = [];
  public user;
  public selectedForm;
  public isWorking = false;

  public isLocal = false;

  public useEvaluapsi = true;
  public aprovationScore = 0;

  public exclude = false;

  public editingIndex = -1;

  public editingFormId = null;
  public formTitle = '';

  public defaultTag = '';

  public selectedFormTitle = '';
  public infoTests: TestInfoModel[] = [];
  public selectedInfo?: TestInfoModel;

  public evaluatedForm = this.fb.group({
    email:['', Validators.email],
    name:['', Validators.required],
    surname:['', Validators.required],
    alias:[''],
    birthDate:[''],
    studies:[''],
    sex:['Masculino'],
    phone:[''],
    password:[''],
    role:['evaluated'],
    pf16:[''],
    pf16Photo:[false],
    cleaver:[''],
    cleaverPhoto:[false],
    allPort:[''],
    allPortPhoto:[false],
    mmpi2:[''],
    mmpi2Photo:[false],
    mmpia:[''],
    mmpiaPhoto:[false],
    mips:[''],
    mipsPhoto:[false],
    terman:[''],
    termanPhoto:[false],
    kostick:[''],
    kostickPhoto:[false],
    ipv:[''],
    ipvPhoto:[false],
    zavic:[''],
    zavicPhoto:[false],
    barsit:[''],
    barsitPhoto:[false],
    domino:[''],
    dominoPhoto:[false],
    city:[''], 
    country:[''], //ADDRESS
    profession:[''],
    company:[''],
    notes:[''],
    bis11:[''],
    bis11Photo:[false],
    chaside:[''],
    chasidePhoto:[false],
    formPhoto:[false],
    form:[''],
    photo:[false],
    isCustomBrand:[false],
  })

  public groups: TestGroup[] = [];
  public selectedTests: CustomTest[] = [];

  public testGroup = '';
  public addedCustomTests: CustomTest[] = [];
  public checkedCustomTests: boolean[] = [];
  public customTestsPhotos: boolean[] = [];

  public secureTests = false;

  constructor(
    private fb: FormBuilder, 
    private userService: UserService, 
    private testService: TestService, 
    private emailService:EmailService, 
    private router:Router,
    public domainService: DomainService,
    private customTestService: CustomTestService,
    
    ) { 

  }

  async ngOnInit(){
 
    this.user = await this.userService.getUser().toPromise();
    this.testService.getInfoTests({}).subscribe(
      resp => {
        this.infoTests = resp;
      },
      err => console.log(err)
    )
    if (this.user.remainingTests > 0 && this.user.showInfoDialog) {
      this.userService.updateUser({email: this.user.email, showInfoDialog: false}).subscribe();
      Swal.fire({
        icon: 'info',
        html: `<p>Por favor, antes de iniciar con la asignación de pruebas, te sugerimos leer el contenido del menú &quot;<b>Modo de uso</b>&quot;, para familiarizarte con algunos conceptos. Esto te ayudará a comprender mejor el funcionamiento de la plataforma.</p>`,
        confirmButtonText: 'Ir a Modo de uso',
        showCancelButton: true,
        cancelButtonText: 'Cerrar'
      }).then ( resp => {
        if (resp.isConfirmed) {
          this.router.navigate(['/dashboard/info']);
        }
      })
    }


    if (this.user.isCustomBrand){
      this.evaluatedForm.get('isCustomBrand').setValue(true);
      this.useEvaluapsi = false;
    }
    this.testService.getUserForms({email:this.user.email}).subscribe(
      resp=>{
        this.forms = resp;
      },
      err=>console.log(err)
    )
    this.editor = new Editor();
    let psw = Math.random().toString(36).substring(4,8);
    this.evaluatedForm.get('password').setValue(psw);
    this.customTestService.getTestGroups({
      "$or": [
        {userId: this.user._id},
        {active: true}
      ]
    }).subscribe(
      resp => {
        this.groups = resp;
        if (this.groups.length > 0){
          this.testGroup = this.groups[0]._id;
          this.getCustomTests();
        }
      }
    )
  }

  async shareBrandLink(){
    let url = `${location.origin}/login?uid=${this.user._id}`;
    await navigator.clipboard.writeText(url);
    Swal.fire({
      icon:'success',
      text:'Enlace copiado al portapapeles',
      showConfirmButton: false,
      timer: 1500
    })
  }

  getCustomTests(){
    setTimeout(() => {
      this.customTestService.getCustomTests({groupId: this.testGroup, active: true}).subscribe(
        resp => {
          this.selectedTests = resp;
          this.checkedCustomTests = new Array(this.selectedTests.length).fill(false);
          this.customTestsPhotos = new Array(this.selectedTests.length).fill(false);
          this.addedCustomTests = [];

        }
      )
    }, 300)
  }

  toggleCustomTests(){
    setTimeout(() => {
      this.checkedCustomTests.forEach((x, i) => {
        let addedIndex = this.addedCustomTests.findIndex(y => y._id == this.selectedTests[i]._id);
        if (x){
          if (addedIndex == -1){
            this.addedCustomTests.push(this.selectedTests[i]);
          }
        }else if (addedIndex > -1){
          this.addedCustomTests.splice(addedIndex, 1);
        }
      })
    }, 200)
  }

  async create(){


    if (!this.evaluatedForm.value.birthDate){
      Swal.fire({
        icon: 'warning',
        text: 'El campo fecha de nacimiento es obligatorio'
      })
      return
    }

    if(((this.evaluatedForm.value.password.length>0&&this.evaluatedForm.value.email.length>0) || this.isLocal)&&this.evaluatedForm.value.name.length>0&&this.evaluatedForm.value.surname.length>0||this.exists){
      let selectedTests=[];
      if (this.evaluatedForm.get('pf16').value==true){
        selectedTests.push("16PF");
      }
      if (this.evaluatedForm.get('cleaver').value==true){
        selectedTests.push('CLEAVER');
      }
      if (this.evaluatedForm.get('allPort').value==true){
        selectedTests.push('ALL PORT');
      }
      if (this.evaluatedForm.get('terman').value==true){
        selectedTests.push('TERMAN');
      }
      if (this.evaluatedForm.get('kostick').value==true){
        selectedTests.push('KOSTIK');
      }
      if (this.evaluatedForm.get('zavic').value==true){
        selectedTests.push('ZAVIC');
      }
      if (this.evaluatedForm.get('ipv').value==true){
        selectedTests.push('IPV');
      }
      if (this.evaluatedForm.get('barsit').value==true){
        selectedTests.push('BARSIC');
      }
      if (this.evaluatedForm.get('mmpi2').value==true){
        selectedTests.push('MMPI2');
      }
      if (this.evaluatedForm.get('mmpia').value==true){
        selectedTests.push('MMPIA');
      }
      if (this.evaluatedForm.get('mips').value==true){
        selectedTests.push('MIPS');
      }
      if (this.evaluatedForm.get('bis11').value==true){
        selectedTests.push('BIS11');
      }
      if (this.evaluatedForm.get('chaside').value==true){
        selectedTests.push('CHASIDE');
      }
      if (this.evaluatedForm.get('domino').value==true){
        selectedTests.push('DOMINO');
      }
      if (this.evaluatedForm.get('form').value==true){
        if (this.formModel.length>0) selectedTests.push('FORMULARIO');
        if (this.formModel.length == 0){
          let resp = await Swal.fire({
            text:'Debe crear o seleccionar un formulario',
            confirmButtonText:'Volver',
          })
          return null
        }
      }

      if (this.user.isCustomBrand){
        this.evaluatedForm.get('isCustomBrand').setValue(!this.useEvaluapsi);
      }else{
        this.evaluatedForm.get('isCustomBrand').setValue(false);
      }
      // console.log(this.addedCustomTests)
      if(this.evaluatedForm.valid && (selectedTests.length>0 || this.addedCustomTests.length>0)){
        let credits = 0;
        credits = selectedTests.length;
        for (let test of selectedTests){
          if (test == '16PF'&&this.evaluatedForm.value.pf16Photo) credits++; 
          if (test == '16PF'&&this.evaluatedForm.value.pf16Form) credits++; 
          if (test == 'CLEAVER'&&this.evaluatedForm.value.cleaverPhoto){
            credits++; 
          } 
          if (test == 'CLEAVER' && this.useCleaverHF){
            credits++;
          }
          if (test == 'ALL PORT'&&this.evaluatedForm.value.allPortPhoto) credits++; 
          if (test == 'TERMAN'&&this.evaluatedForm.value.termanPhoto) credits++; 
          if (test == 'KOSTIK'&&this.evaluatedForm.value.kostickPhoto) credits++; 
          if (test == 'ZAVIC'&&this.evaluatedForm.value.zavicPhoto) credits++; 
          if (test == 'IPV'&&this.evaluatedForm.value.ipvPhoto) credits++; 
          if (test == 'BARSIC'&&this.evaluatedForm.value.barsitPhoto) credits++; 
          if (test == 'MMPI2'&&this.evaluatedForm.value.mmpi2Photo) credits++; 
          if (test == 'MMPIA'&&this.evaluatedForm.value.mmpiaPhoto) credits++; 
          if (test == 'BIS11'&&this.evaluatedForm.value.bis11Photo) credits++; 
          if (test == 'MIPS'&&this.evaluatedForm.value.mipsPhoto) credits++; 
          if (test == 'CHASIDE'&&this.evaluatedForm.value.chasidePhoto) credits++; 
          if (test == 'DOMINO'&&this.evaluatedForm.value.dominoPhoto) credits++; 
          if (test == 'FORMULARIO'&&this.evaluatedForm.value.formPhoto) credits++; 
        }

        for (let photo of this.customTestsPhotos){
          if (photo) credits++;
        }

        // for (let test of this.checkedCustomTests){
        //   if (test) {
        //     credits++;
        //   }
        // }
        let alertText = `Esta acción consumirá ${credits} créditos. Recuerde que si usted ha solicitado fotografías para sus pruebas, éstas consumen 1 crédito cada una y se descontarán aunque el evaluado no posea cámara o no habilite los permisos correspondientes`
        if (this.user.isUnlimited){
          alertText = `Esta acción no consumirá créditos, ya que usted posee una cuenta ilimitada.`
        }
        Swal.fire({
          icon:'info',
          text: alertText,
          showCancelButton:true,
          cancelButtonText:'Cancelar',
          confirmButtonText:'Aceptar'
        }).then(
          async resp=>{
            if(resp.isConfirmed){
              try{
                let exist = await this.userService.getUserByEmail(this.evaluatedForm.get('email').value).toPromise();
                if (exist && (exist.role == 'admin' || exist.role == 'client')){
                  this.exists = false;
                  this.evaluatedForm.reset();
                  this.html = "";                  
                  return Swal.fire("No puedes asignarle pruebas a este usuario");
                }

              }catch(e){
                
              }
              this.userService.getUser().subscribe(
                resp=>{
                  if(credits>resp.remainingTests && !this.user.isUnlimited){
                    Swal.fire({
                      text:'Has seleccionado más evaluaciones de las que tienes disponibles',
                      showCancelButton:true,
                      showConfirmButton: this.user.isEnterprise ? false : true,
                      confirmButtonText:'COMPRAR PRUEBAS',
                      cancelButtonText:'Cerrar'
                    }).then(resp=>{
                      if(resp.isConfirmed){
                        this.router.navigateByUrl('dashboard/plans')
                      }else window.location.reload();
                    })
                  }else{
                    this.isWorking = true;
                    if (!this.user.isUnlimited){
                      this.userService.updateUser({email:resp.email, remainingTests:(resp.remainingTests-credits)}).subscribe();
                    }
                    if (this.isLocal) {
                      this.evaluatedForm.get('email').setValue(`${this.evaluatedForm.value.name} ${this.evaluatedForm.value.surname}`);
                    }
                    this.userService.register(this.evaluatedForm.value).subscribe(
                      resp=>{
                        for (let test of selectedTests){
                          let camera = false;
                          let form = false;
                          if (test == '16PF') camera = this.evaluatedForm.value.pf16Photo;
                          if (test == 'CLEAVER') camera = this.evaluatedForm.value.cleaverPhoto;
                          if (test == 'ALL PORT') camera = this.evaluatedForm.value.allPortPhoto;
                          if (test == 'TERMAN') camera = this.evaluatedForm.value.termanPhoto;
                          if (test == 'KOSTIK') camera = this.evaluatedForm.value.kostickPhoto;
                          if (test == 'ZAVIC') camera = this.evaluatedForm.value.zavicPhoto;
                          if (test == 'IPV') camera = this.evaluatedForm.value.ipvPhoto;
                          if (test == 'BARSIC') camera = this.evaluatedForm.value.barsitPhoto;
                          if (test == 'MMPI2') camera = this.evaluatedForm.value.mmpi2Photo;
                          if (test == 'MMPIA') camera = this.evaluatedForm.value.mmpiaPhoto;
                          if (test == 'BIS11') camera = this.evaluatedForm.value.bis11Photo;
                          if (test == 'MIPS') camera = this.evaluatedForm.value.mipsPhoto;
                          if (test == 'CHASIDE') camera = this.evaluatedForm.value.chasidePhoto;
                          if (test == 'DOMINO') camera = this.evaluatedForm.value.dominoPhoto;
                          if (test == 'FORMULARIO') camera = this.evaluatedForm.value.formPhoto;
                          let completeForm = {
                            data:this.formModel, 
                            userEmail:this.user.email, 
                            title:this.formTitle,
                            aprovationScore: this.aprovationScore,
                            successMessage: this.successMessage,
                            failMessage: this.failMessage,
                            exclude: this.exclude
                          }
                          let data = {
                            evaluated:this.evaluatedForm.get('email').value,
                            client:this.userService.user.email,
                            clientName:`${this.userService.user.name} ${this.userService.user.surname}`,
                            evaluatedName:`${this.evaluatedForm.get('name').value} ${this.evaluatedForm.get('surname').value}`,
                            type:test,
                            useCleaverHF: this.useCleaverHF,
                            camera:camera,
                            form:form,
                            formModel:this.formModel,
                            completeForm: completeForm,
                            extra:"",
                            baremo:"Argentina",
                            isLocal: this.isLocal,
                            isCustomBrand: this.evaluatedForm.value.isCustomBrand,
                            tags: this.defaultTag ? [{name: this.defaultTag, color: '#687384'}] : [],
                            isSecure: this.secureTests
                          };
                          if (test=="MMPI2") {
                            data.extra = this.mmpi2Extra?'Abreviado':'Extendido';
                            data.baremo = this.baremo;
                          }
                          if (test=="MMPIA") {
                            data.extra = this.mmpiaExtra?'Abreviado':'Extendido';
                            data.baremo = this.baremo;
                          }
                          this.testService.createTest(data).then(
                            x=>{
                              this.evaluatedForm.reset();
                              this.isWorking = true;
                            }
                          );
                        }
                          let index = 0
                          for (let test of this.addedCustomTests){

                            let camera = this.customTestsPhotos[index];
                            index++;
                            let form = false;

                            let data = {
                              evaluated:this.evaluatedForm.get('email').value,
                              client:this.userService.user.email,
                              clientName:`${this.userService.user.name} ${this.userService.user.surname}`,
                              evaluatedName:`${this.evaluatedForm.get('name').value} ${this.evaluatedForm.get('surname').value}`,
                              type:test.title,
                              camera:camera,

                              form:form,
                              formModel:this.formModel,
                              completeForm: test._id,
                              extra:"",
                              baremo:"Argentina",
                              isLocal: this.isLocal,
                              isCustomBrand: this.evaluatedForm.value.isCustomBrand,
                              tags: this.defaultTag ? [{name: this.defaultTag, color: '#687384'}] : [],
                              isCustomTest: true
                            };

                            this.testService.createTest(data).then(
                              x=>{
                                this.evaluatedForm.reset();
                                this.isWorking = true;
                              }
                            );

                          }
                          var data;
                          if(!this.defaultEmail){
                            var html;
                            if (this.html.type == "doc"){
                              html = toHTML(this.html);
                            }else{
                              html = this.html;
                            }
                            data = {
                              email:this.evaluatedForm.get('email').value,
                              password:this.evaluatedForm.get('password').value,
                              html:html,
                              subject:this.subject,
                              isCustomBrand: this.evaluatedForm.value.isCustomBrand,
                              uid: this.userService.user._id
                            }                            
                          }else{
                            data = {
                              email:this.evaluatedForm.get('email').value,
                              password:this.evaluatedForm.get('password').value,
                              isCustomBrand: this.evaluatedForm.value.isCustomBrand,
                              uid: this.userService.user._id
                            }      
                          }
                          let text = ''
                          if (!this.isLocal){
                            text = 'Usuario creado y notificado';
                            this.emailService.evaluatedRegister(data).subscribe();
                          }else{
                            text = `Prueba creada`
                          }
                          Swal.fire(text,"", 'success').then(
                            resp=>{
                              if(resp.isConfirmed) window.location.reload();
                            }
                          );
              
                      },
                      err=>{
                        // console.log({err})
                        if(err.error=='Usuario existente'){
                          this.userService.getUserByEmail(this.evaluatedForm.get('email').value).subscribe(
                            resp=>{
                              if (resp.role=="client"||resp.role=="admin") {
                                this.exists = false;
                                this.evaluatedForm.reset();
                                this.html = "";                  
                                Swal.fire("No puedes asignarle pruebas a este usuario");
                              }else{
                                for (let test of selectedTests){
                                  let camera = false;
                                  let form = false;

                                  if (test == '16PF') camera = this.evaluatedForm.value.pf16Photo;
                                  if (test == 'CLEAVER') camera = this.evaluatedForm.value.cleaverPhoto;
                                  if (test == 'ALL PORT') camera = this.evaluatedForm.value.allPortPhoto;
                                  if (test == 'TERMAN') camera = this.evaluatedForm.value.termanPhoto;
                                  if (test == 'KOSTIK') camera = this.evaluatedForm.value.kostickPhoto;
                                  if (test == 'ZAVIC') camera = this.evaluatedForm.value.zavicPhoto;
                                  if (test == 'IPV') camera = this.evaluatedForm.value.ipvPhoto;
                                  if (test == 'BARSIC') camera = this.evaluatedForm.value.barsitPhoto;
                                  if (test == 'MMPI2') camera = this.evaluatedForm.value.mmpi2Photo;
                                  if (test == 'MMPIA') camera = this.evaluatedForm.value.mmpiaPhoto;
                                  if (test == 'BIS11') camera = this.evaluatedForm.value.bis11Photo;
                                  if (test == 'MIPS') camera = this.evaluatedForm.value.mipsPhoto;
                                  if (test == 'CHASIDE') camera = this.evaluatedForm.value.chasidePhoto;
                                  if (test == 'DOMINO') camera = this.evaluatedForm.value.dominoPhoto;
                                  if (test == 'FORMULARIO') camera = this.evaluatedForm.value.formPhoto;

                                  let completeForm = {
                                    data:this.formModel, 
                                    userEmail:this.user.email, 
                                    title:this.formTitle,
                                    aprovationScore: this.aprovationScore,
                                    successMessage: this.successMessage,
                                    failMessage: this.failMessage,
                                    exclude: this.exclude

                                  }
                                  
                                  let data = {
                                    evaluated:this.evaluatedForm.get('email').value,
                                    evaluatedName:`${this.evaluatedForm.get('name').value} ${this.evaluatedForm.get('surname').value}`,
                                    client:this.userService.user.email,
                                    clientName:`${this.userService.user.name} ${this.userService.user.surname}`,
                                    type:test,
                                    useCleaverHF: this.useCleaverHF,
                                    camera:camera,
                                    form:form,
                                    formModel:this.formModel,
                                    completeForm: completeForm,
                                    extra:"",
                                    baremo:"Argentina",
                                    tags: this.defaultTag ? [{name: this.defaultTag, color: '#687384'}] : [],
                                    isSecure: this.secureTests,

                                    isLocal: this.isLocal,
                                    isCustomBrand: this.evaluatedForm.value.isCustomBrand
                                  };
                                  if (test=="MMPI2") {
                                    data.extra = this.mmpi2Extra?'Abreviado':'Extendido';
                                    data.baremo = this.baremo;
                                  }
                                  if (test=="MMPIA") {
                                    data.extra = this.mmpiaExtra?'Abreviado':'Extendido';
                                    data.baremo = this.baremo;
                                  }                             
                                  this.testService.createTest(data).then(
                                    x=>{
                                      this.evaluatedForm.reset();
                                    }
                                    );
                                  }
                                  let index = 0;
                                  for (let test of this.addedCustomTests){

                                    let camera = this.customTestsPhotos[index];
                                    index++;
                                    let form = false;
        
                                    let data = {
                                      evaluated:this.evaluatedForm.get('email').value,
                                      client:this.userService.user.email,
                                      clientName:`${this.userService.user.name} ${this.userService.user.surname}`,
                                      evaluatedName:`${this.evaluatedForm.get('name').value} ${this.evaluatedForm.get('surname').value}`,
                                      type:test.title,
                                      camera:camera,
                                      form:form,
                                      formModel:this.formModel,
                                      completeForm: test._id,
                                      extra:"",
                                      baremo:"Argentina",
                                      isLocal: this.isLocal,
                                      isCustomBrand: this.evaluatedForm.value.isCustomBrand,
                                      tags: this.defaultTag ? [{name: this.defaultTag, color: '#687384'}] : [],
                                      isCustomTest: true
                                    };
        
                                    this.testService.createTest(data).then(
                                      x=>{
                                        this.evaluatedForm.reset();
                                        this.isWorking = true;
                                      }
                                    );
        
                                  }

                                  var data;
                                  if(!this.defaultEmail){
                                    var html;
                                    if (this.html.type == "doc"){
                                      html = toHTML(this.html);
                                    }else{
                                      html = this.html;
                                    }
                                    data = {
                                      email:this.evaluatedForm.get('email').value,
                                      password:this.evaluatedForm.get('password').value,
                                      html:html,
                                      subject:this.subject,
                                      isCustomBrand: this.evaluatedForm.value.isCustomBrand,
                                      uid: this.userService.user._id
                                    }                            
                                  }else{
                                    data = {
                                      email:this.evaluatedForm.get('email').value,
                                      password:this.evaluatedForm.get('password').value,
                                      isCustomBrand: this.evaluatedForm.value.isCustomBrand,
                                      uid: this.userService.user._id
                                    }      
                                  }
                                  let text = ''
                                  if (!this.isLocal){
                                    text = 'Usuario creado y notificado';
                                    this.emailService.evaluatedRegister(data).subscribe();
                                  }else{
                                    text = `Prueba creada`
                                  }
                                  Swal.fire(text,"", 'success').then(
                                    resp=>{
                                      if(resp.isConfirmed) window.location.reload();
                                    }
                                  );
                              }
                            },
                            err=>console.log(err)
                          )
                        }else{
                          Swal.fire('Error',err.error, 'error');
                          this.exists = false;
                          this.evaluatedForm.reset();
                        }
                      }
                    )
                  }
                },
                err=>console.log(err)
              )
            }
          }
        )

      }else{
        if (selectedTests.length==0){
          Swal.fire("Debe seleccionar alguna prueba");
        }
      }
    }else {
      if (this.evaluatedForm.value.password.length==0) Swal.fire("Debe ingresar una contraseña");
      if (this.evaluatedForm.value.email.length==0) Swal.fire("Debe ingresar una dirección de email");
      if (this.evaluatedForm.value.name.length==0) Swal.fire("Debe completar el campo 'Nombre'");
      if (this.evaluatedForm.value.surname.length==0) Swal.fire("Debe completar el campo 'Apellido'");
    }
  }
  reset(){
    this.evaluatedForm.reset();
    this.exists = false;
  }

  updateHTML(){
    if (!this.defaultEmail){
      let link = this.user.isCustomBrand && !this.useEvaluapsi ? `<a href="https://mievaluado.com/login?uid=${this.user._id}">mievaluado.com</a>`: '<a href="https://plataforma.evaluapsi.com/login">Evalúa Psi</a>'
      let html = `
      <div style="width:100%; justify-content:center">
          <div style="width:700px">
          
              <h3>Estimado/a:</h3>
              <p>Usted fue seleccionado para realizar una batería de evaluaciones psicométricas, estas podrán variar de una sola evaluación a varias, dependiendo de quien se las asigno y permitirán conocer más de sus intereses, habilidades, comportamientos y personalidad.</p>
              <h3>Recomendaciones</h3>
              <p>Por favor, cuando haga el Login (acceso al sistema) para realizarlas, es sumamente importante que siga nuestras recomendaciones: </p>
              <i>
                  <p>- Tómese un tiempo de aproximadamente 60 minutos, tiempo durante el cual deberá apagar o silenciar su celular.</p>
                  <p>- Ubíquese en un entorno cómodo, silencioso, con buena conexión de internet y libre de distracciones para poder enfocarse y no cometer errores.</p>
              </i>
              <h3>Datos de acceso:</h3>
              <i>
                  <p>Link de Login: ${link}</p>
                  <p>Usuario: ${this.evaluatedForm.value.email}</p>
                  <p>Contraseña: ${this.evaluatedForm.value.password}</p>
              </i>
              <h3>Instrucciones:</h3>
              <i>
                  <p>- Ingrese al siguiente link que le enviamos.</p>
                  <p>- Ingrese su usuario y clave.</p>
                  <p>- Lea detenidamente las Instrucciones del sistema.</p>
              </i> 
              <p>Los resultados serán interpretados y utilizados confidencialmente.</p>
          
          </div>
      
      
      </div>
          
      `;
    this.html = toDoc(html);
    }
  }

  navigateToForms(){
    this.router.navigate(['dashboard/forms'])
  }

  checkState(){
    this.editor.destroy();
    this.editor = new Editor();
    let link = this.user.isCustomBrand && !this.useEvaluapsi ? `<a href="https://mievaluado.com/login?uid=${this.user._id}">mievaluado.com</a>`: '<a href="https://plataforma.evaluapsi.com/login">Evalúa Psi</a>'
    // let html = `
    //   <h3>Datos de acceso:</h3>
    //   <p>Link de Login: ${link}</p>
    //   <p>Email: ${this.evaluatedForm.value.email}</p>
    //   <p>Contraseña: ${this.evaluatedForm.value.password}</p>
    // `;

    let html = `
    <div style="width:100%; justify-content:center">
        <div style="width:700px">
        
            <h3>Estimado/a:</h3>
            <p>Usted fue seleccionado para realizar una batería de evaluaciones psicométricas, estas podrán variar de una sola evaluación a varias, dependiendo de quien se las asigno y permitirán conocer más de sus intereses, habilidades, comportamientos y personalidad.</p>
            <h3>Recomendaciones</h3>
            <p>Por favor, cuando haga el Login (acceso al sistema) para realizarlas, es sumamente importante que siga nuestras recomendaciones: </p>
            <i>
                <p>- Tómese un tiempo de aproximadamente 60 minutos, tiempo durante el cual deberá apagar o silenciar su celular.</p>
                <p>- Ubíquese en un entorno cómodo, silencioso, con buena conexión de internet y libre de distracciones para poder enfocarse y no cometer errores.</p>
            </i>
            <h3>Datos de acceso:</h3>
            <i>
                <p>Link de Login: ${link}</p>
                <p>Usuario: ${this.evaluatedForm.value.email}</p>
                <p>Contraseña: ${this.evaluatedForm.value.password}</p>
            </i>
            <h3>Instrucciones:</h3>
            <i>
                <p>- Ingrese al siguiente link que le enviamos.</p>
                <p>- Ingrese su usuario y clave.</p>
                <p>- Lea detenidamente las Instrucciones del sistema.</p>
            </i> 
            <p>Los resultados serán interpretados y utilizados confidencialmente.</p>
        
        </div>
    
    
    </div>
        
    `;


    this.html = toDoc(html);
  }

  handleFocusEmail(){
    this.searching = true;
    this.userService.getUserByEmail(this.evaluatedForm.get('email').value).subscribe(
      resp=>{
        if (resp) {
          this.exists = true;
          this.evaluatedForm.get('name').setValue(resp.name);
          this.evaluatedForm.get('surname').setValue(resp.surname);
          this.evaluatedForm.get('alias').setValue(resp.alias);
          this.evaluatedForm.get('birthDate').setValue(formatDate(resp.birthDate, 'yyyy-MM-dd', 'en'));
          this.evaluatedForm.get('studies').setValue(resp.studies);
          this.evaluatedForm.get('sex').setValue(resp.sex);
          this.evaluatedForm.get('phone').setValue(resp.phone);
          this.evaluatedForm.get('country').setValue(resp.country); //ADDRESS
          this.evaluatedForm.get('city').setValue(resp.city);
          this.evaluatedForm.get('notes').setValue(resp.notes);
          this.evaluatedForm.get('company').setValue(resp.company);
          this.evaluatedForm.get('profession').setValue(resp.profession);
          this.evaluatedForm.get('password').setValue(resp.password);
        }
      },
      err=>{
        this.searching = false;
        this.exists = false;

      }
    )
  }

  saveHtml(){
    var html;
    if (this.html.type == "doc"){
      html = toHTML(this.html);
    }else{
      html = this.html;
    }   
  }

  setBaremo(e){
    this.baremo = (e.target.value)
  }

  createField(type){

    if (this.editingIndex != -1){
      let type = this.formModel[this.editingIndex].type;
      this.formModel[this.editingIndex].text = this.title;
      this.formModel[this.editingIndex].value = this.value;
      this.formModel[this.editingIndex].correctValue = this.correctValue;
      if (type=='radio'){
        this.formModel[this.editingIndex].data = this.radioField;
      }
      if (type=='multiple'){
        this.formModel[this.editingIndex].data = this.multipleField;
      }
      this.editingIndex = -1;
      this.title = "";
      this.value = null;
      this.correctValue = null;
      this.option.text = "";
      this.option.value = null;
      this.radioField = [];
      this.multipleField = [];
      this.creatingFieldType = '';
      return
    }
    if (type=='text'){
      this.formModel.push({type:'text', text:this.title})
      this.title = "";
      this.creatingFieldType = '';
    }

    if (type=='number'){
      this.formModel.push({type:'number', text:this.title, correctValue: this.correctValue, value:this.value})
      this.title = "";
      this.value = null;
      this.correctValue = null;
      this.creatingFieldType = '';
    }

    if (type=='radio'){
      this.formModel.push({type:'radio', text:this.title, data:this.radioField})
      this.title = "";
      this.option.text = "";
      this.option.value = null;
      this.creatingFieldType = '';
      this.radioField = [];
    }

    if (type=='multiple'){
      this.formModel.push({type:'multiple', text:this.title, data:this.multipleField})
      this.title = "";
      this.option.text = "";
      this.option.value = null;
      this.creatingFieldType = '';
      this.multipleField = [];
    }
  }

  addRadio(){
    if (this.option){
      let newOption = {
        text: this.option.text,
        value: this.option.value
      }
      this.radioField.push(newOption);
      this.option.text = "";
      this.option.value = null;
    }
  }

  addMultiple(){
    if (this.option){
      let newOption = {
        text: this.option.text,
        value: this.option.value
      }
      this.multipleField.push(newOption);
      this.option.text = "";
      this.option.value = null;    
    }
  }

  deleteOption(i: number, type: string){
    if (type=='radio'){
      this.radioField.splice(i,1);
    }
    if (type=='multiple'){
      this.multipleField.splice(i,1);
    }
  }


  deleteField(i){
    this.formModel.splice(i,1);
  }

  checkScore(form, aprovationScore){
    let score = 0;
    for (let field of form){
      if (field.type=='number'){
        score += field.value;
      }
      if (field.type=='radio'){
        let maxValue = 0;
        for (let option of field.data){
          if (option.value>maxValue) maxValue = option.value;
        }
        score += maxValue;
      }
      if (field.type=='multiple'){
        let total = 0;
        for (let option of field.data){
          total += option.value;
        }
        score += total;
      }
    }
    if (score<aprovationScore){
      this.evaluatedForm.get('form').setValue(false);
      Swal.fire({
        icon:'warning',
        text:'La puntuación de aprobación es mayor a la puntuación total del formulario'
      })
      return false
    }
    return true;
  }

  saveForm(){
    let title = this.formTitle;
    let goodScore = this.checkScore(this.formModel, this.aprovationScore);
    if (!goodScore) return
    if (title){
      let obj = {
        data:this.formModel, 
        userEmail:this.user.email, 
        title:title,
        aprovationScore: this.aprovationScore,
        successMessage: this.successMessage,
        failMessage: this.failMessage,
        exclude: this.exclude
      }
      if (this.editingFormId){
        this.testService.updateForm({_id:this.editingFormId, ...obj}).subscribe(
          resp => {
            Swal.fire({
              icon:'success',
              text: 'Formulario actualizado',
              timer: 2000
            })
          }
        )
      }else{
        this.testService.createForm(obj).subscribe(
          resp=>{
            this.forms.push(resp);
          },
          err=>console.log(err)
        )
      }
    }
  }

  changeForm(f){
    if (f == 'Crear nuevo'){
      $('#formModal').modal('hide');
      return this.router.navigate(['dashboard/forms'])
    }
    this.testService.getUserForms({email:this.user.email}).subscribe(
      resp=>{
        this.forms = resp;
      },
      err=>console.log(err)
    )
    this.formModel = f.data;
    this.editingFormId = f._id;
    this.formTitle = f.title;
    this.successMessage = f.successMessage;
    this.failMessage = f.failMessage;
    this.exclude = f.exclude;
    this.aprovationScore = f.aprovationScore;
    
  }

  deleteForm(){
    Swal.fire({
      text:'¿Borrar formulario?',
      showCancelButton:true
    }).then(
      resp=>{
        if (resp.isConfirmed){
          this.testService.deleteForm(this.selectedForm).subscribe(
            resp=>{
              location.reload()
            }
          )
        }
      }
    )
  }

  editField(i){
    this.editingIndex = i;
    this.creatingFieldType = this.formModel[i].type;
    this.title = this.formModel[i].text;
    if (this.formModel[i].type=='radio'){
      this.radioField = this.formModel[i].data;
    }
    if (this.formModel[i].type=='multiple'){
      this.multipleField = this.formModel[i].data;
    }
    this.value = this.formModel[i].value;
    this.correctValue = this.formModel[i].correctValue;
  }

  selectForm(f){
    // console.log(f)
    if (f == 'Crear nuevo'){
      $('#formModal').modal('hide');
      this.navigateToForms()
    }
    let form = this.forms.find(x=>x._id==f);
    this.selectedForm = f;
    this.selectedFormTitle = form.title;
    this.changeForm(form);
  }

  handleShowInfo(type: string) {
    let test = this.infoTests.find(x => x.type === type);
    if (!test) {
      return
    }
    this.selectedInfo = test;
    document.querySelector('#main-description').innerHTML = test.mainDescription;
    
    $('#infoModal').modal('show');
  }

  

}
